import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import {
  userIsLogged,
  apiGetSysSettings,
  getRoute,
  apiDeleteSysSetting,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneSistemaScreen() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);

  const { selectedLinguaTesto } = useLingueStore((state) => state);

  const breadCrumb = [
    { title: selectedLinguaTesto?.GestioneSistemaBreadcrumb1, link: null },
  ];

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");

    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 40)) {
        navigate("/");
      }
      initPage();
    }
  }

  function initPage() {
    console.log("initPage");

    apiGetSysSettings(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setRows(response.data);
      } else {
        setRows([]);
      }
    });
  }

  function stopPage() {
    console.log("stopPage");
  }

  const columns = [
    {
      field: "idSetting",
      headerName: selectedLinguaTesto?.GestioneSistemaColumnID,
      flex: 1,
      headerClassName: "tableHeader",
    },
    {
      field: "chiave",
      headerName: selectedLinguaTesto?.GestioneSistemaColumnKey,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "valore",
      headerName: selectedLinguaTesto?.GestioneSistemaColumnValue,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "settingGroup",
      headerName: selectedLinguaTesto?.GestioneSistemaColumnSettingGroup,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "action",
      headerName: "",
      flex: 2,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          console.log(params.row);
          const action = event.target.dataset.action;
          if (action == "edit") {
            handleEdit(params.row.idSetting);
          } else if (action == "delete") {
            handleDelete(params.row.idSetting);
          }
        };

        return (
          <div className="tableActionButton">
            <img
              data-action="edit"
              src="/images/edit_btn.svg"
              title={selectedLinguaTesto?.GestioneSistemaImgEdit}
              onClick={onClick}
            />
            <img
              data-action="delete"
              data-rowid=""
              src="/images/delete_btn.svg"
              title={selectedLinguaTesto?.GestioneSistemaImgDelete}
              onClick={onClick}
              style={{ display: "none" }}
            />
            <img
              data-action="restore"
              data-rowid=""
              src="/images/restore_user.svg"
              title={selectedLinguaTesto?.GestioneSistemaImgRestore}
              onClick={onClick}
              style={{ display: "none" }}
            />
          </div>
        );
      },
    },
  ];

  function handleNew() {
    const dest = "/sistema/-1";
    navigate(dest);
  }

  function handleEdit(idSetting) {
    const dest = "/sistema/" + idSetting;
    navigate(dest);
  }

  function handleDelete(idSetting) {
    setIdToDelete(idSetting);
    setDeleteDialogOpen(true);
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    setDeleteDialogOpen(false);

    apiDeleteSysSetting(idToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  function handleGruppiTab() {
    const dest = "/sistema/lingue";
    navigate(dest);
  }

  return (
    <div id="avp-gestioneavp-screen">
      <AvpHeader selectedMenuId={"sistema"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#sistema"} />
      <div id="avp-cms-screen-container">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneSistemaAlertSucess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneSistemaAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-tab clearfix">
          <div className={"avp-cms-tab-item avp-cms-tab-item-selected"}>
            {selectedLinguaTesto?.GestioneSistemaTabSetting}
          </div>
          <div className={"avp-cms-tab-item"} onClick={handleGruppiTab}>
            {selectedLinguaTesto?.GestioneSistemaTabLang}
          </div>
        </div>

        <div className="avp-cms-screen-title">
          {selectedLinguaTesto?.GestioneSistemaTitle}
        </div>
        <div className="avp-cms-screen-content">
          <div className="avp-cms-screen-toolbar clearfix">
            <div className="avp-cms-screen-toolbar-title">
              {rows.length}&nbsp;{selectedLinguaTesto?.GestioneSistemaSubtitle}
            </div>
            <div className="avp-cms-screen-toolbar-filters"></div>
            <div
              className="avp-cms-screen-toolbar-add"
              onClick={handleNew}
              style={{ display: "none" }}
            >
              <button>{selectedLinguaTesto?.GestioneSistemaButtonNew}</button>
            </div>
          </div>

          <DataGrid
            disableColumnMenu
            getRowId={(row) => row.idSetting}
            rows={rows}
            columns={columns}
            getRowClassName={(params) => "tableRow"}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 30, 50]}
            disableRowSelectionOnClick
          />
        </div>
      </div>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Conferma eliminazione"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.GestioneSistemaDialogTitle}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>
            {selectedLinguaTesto?.GestioneSistemaDialogUndo}
          </Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneSistemaDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
